import {
  fromLocalToDBTimestamp,
  completionTimeBuffer,
  getDateTime,
} from '@pinnacleautomotive/clarity-components';
import { createSelector } from '@reduxjs/toolkit';
import isNull from 'lodash.isnull';
import omitBy from 'lodash.omitby';

const selectNewOrderData = state => state.newOrder;

export const selectSelectedVendor = createSelector(
  selectNewOrderData,
  state => state.selectedVendor
);

export const selectSelectedDepartment = createSelector(
  selectNewOrderData,
  state => state.selectedDepartment
);

export const selectSelectedPrices = createSelector(
  selectNewOrderData,
  state => state.selectedPrices
);

export const selectSelectedCategories = createSelector(
  selectNewOrderData,
  state => state.selectedCategories
);

export const selectSelectedPricesWithDetails = createSelector(
  selectNewOrderData,
  state =>
    state.prices.filter(price =>
      state.selectedPrices.includes(price.servicePriceId)
    )
);

export const selectPrices = createSelector(
  selectNewOrderData,
  state => state.prices
);

export const selectSelectedVehicle = createSelector(
  selectNewOrderData,
  state => state.selectedVehicle
);

export const selectVehicleNotFound = createSelector(
  selectNewOrderData,
  state => state.vehicleNotFound
);

export const selectEditVehicleModalOpen = createSelector(
  selectNewOrderData,
  state => state.editVehicleModalOpen
);

export const selectObservations = createSelector(
  selectNewOrderData,
  state => state.observation
);

export const selectPricesGrouped = createSelector(selectPrices, state =>
  state.reduce(
    (prev, actual) => ({
      ...prev,
      [actual.service.type]: [...(prev[actual.service.type] || []), actual],
    }),
    {}
  )
);

export const selectIsLoading = createSelector(
  selectNewOrderData,
  state => state.isLoading
);

export const selectIsLoadingServices = createSelector(
  selectNewOrderData,
  state => state.isLoadingServices
);

export const selectIsLoadingVehicle = createSelector(
  selectNewOrderData,
  state => state.isLoadingVehicle
);

export const selectDiscarded = createSelector(
  selectNewOrderData,
  state => state.discarded
);

export const selectSpecialRequests = createSelector(
  selectNewOrderData,
  state => state.specialRequests
);

export const selectedAlternativeOwner = createSelector(
  selectNewOrderData,
  state => state.alternativeOwner
);

export const selectAlternativeOwnerLoading = createSelector(
  selectNewOrderData,
  state => state.alternativeOwnerLoading
);

export const selectAlternativeOwner = createSelector(
  selectNewOrderData,
  state => state.owners
);
export const selectCompletionType = createSelector(
  selectNewOrderData,
  state => state.completionType
);

export const selectEstimatedCompletion = createSelector(
  selectNewOrderData,
  state =>
    getDateTime(new Date(state.createdDate))
      .plus({ minutes: state.servicesTotalComplianceTime })
      .plus({ minutes: completionTimeBuffer })
);

export const selectPromiseDate = createSelector(
  selectNewOrderData,
  state => new Date(state.promiseDate)
);

export const selectSaveError = createSelector(
  selectNewOrderData,
  state => state.saveError
);

export const selectWorkOrderSaved = createSelector(
  selectNewOrderData,
  state => state.workOrderSaved
);

export const getAllDealers = createSelector(
  selectNewOrderData,
  state => state.dealers
);

export const selectDataToSave = createSelector(selectNewOrderData, state =>
  omitBy(
    {
      vehicleId: state.selectedVehicle?.vehicleId,
      priceIds: state.selectedPrices,
      dealerPurchaseOrderNumber: state.po,
      stockNumber: state.stockNumber,
      repairOrder: state.ro,
      observation: state.observation,
      specialRequests: state.specialRequests,
      promiseDate: getPromiseDate(state),
      ownerId: state.alternativeOwner?.personId,
    },
    isNull
  )
);

export const selectEditVehicleDataError = createSelector(
  selectNewOrderData,
  state => state.editVehicleDataError
);

function getPromiseDate(state) {
  return state.completionType === 'promised'
    ? fromLocalToDBTimestamp(new Date(state.promiseDate))
    : null;
}

export const vehicleId = createSelector(
  selectNewOrderData,
  state => state.vehicleId
);
